import { useRef, useCallback } from "react";

export function useDoubleTap({ onDoubleTap, delay = 300 }) {
    const lastTapRef = useRef(0);
    const clickTimeoutRef = useRef(null);

    const detectDoubleTap = useCallback(
        (singleAction) => {
            const now = Date.now();

            if (now - lastTapRef.current < delay) {
                // double-tap detected
                if (clickTimeoutRef.current) {
                    clearTimeout(clickTimeoutRef.current);
                    clickTimeoutRef.current = null;
                }
                onDoubleTap?.();
                lastTapRef.current = 0;
                return true;
            }

            // first tap
            lastTapRef.current = now;
            clickTimeoutRef.current = setTimeout(() => {
                clickTimeoutRef.current = null;
                // only run single action if no double-tap happened
                singleAction?.();
            }, delay + 50);

            return false;
        },
        [onDoubleTap, delay]
    );

    const handleParentTap = useCallback(
        (e) => {
            detectDoubleTap(); // no singleAction for parent
        },
        [detectDoubleTap]
    );

    const wrapChildClick = useCallback(
        (childFunc) => (e) => {
            if (e && typeof e.stopPropagation === "function") e.stopPropagation();
            detectDoubleTap(() => childFunc?.(e));
        },
        [detectDoubleTap]
    );

    return { handleParentTap, wrapChildClick };
}
